export const statusMap = {
  pending: "未定",
  attended: "出席",
  absent: "欠席(本人都合)",
  absent_schcon: "欠席(スクール都合)",
  absent_alert: "欠席(警報)",
};
